export default "__VITE_ASSET__CAtPsFds__"